import $ from 'jquery';
import ValidatedFormView from '../form/ValidatedFormView.js';

const MAX_CHILDREN = 10;
const COLORS_MAP = {
  male: '#f1f8fd',
  female: '#fbf2f8',
  neutral: '#eaeecb',
};

class FormBabyJourney extends ValidatedFormView {
  constructor(options) {
    const validations = {
      ['children[0][name]']: ['required'],
      ['children[0][birthday]']: ['required'],
      ['children[0][gender]']: [{rule: 'radioChecked', param: 'children[0][gender]'}],
      ['privacyPolicy']: [{rule: 'checked', param: 'privacyPolicy'}],
      ['email']: ['required', 'email'],
    };
    super(Object.assign({
      formName: 'form-baby-journey',
      validations: validations,
      onValid: () => {},
    }, options));

    this.reset();
    this.initUpdateColorOnGenderSelect();
    this.initAddChildButton();
    this.initRemoveChildButton();
    this.updateAddChildButtonState();
  }

  reset() {
    this.$form.get(0).reset();
    this.$form.find(this.getChildFieldsetSelector()).slice(1).remove();
    this.$form.find('.form-title-holder').css('background-color', null);
    this.syncChildValidations();
    this.updateChildRemoveButtons();
    this.updateAddChildButtonState();
  }

  initUpdateColorOnGenderSelect() {
    this.$form.on('change', '.js_custom-control-input-radio', (event) => {
      const value = event.target.value;
      const color = COLORS_MAP[value];
      $(event.target).closest('.form-fieldset').find('.form-title-holder').css('background-color', color);
    });
  }

  initAddChildButton() {
    const $button = this.$form.find('#input-add-child');
    $button.on('click', () => {
      if (this.getChildCount() >= MAX_CHILDREN) {
        this.updateAddChildButtonState();
        return;
      }

      const nextIndex = this.getNextChildIndex();
      const $template = this.getLastChildFieldset();
      const currentIndex = this.getChildIndex($template);
      const $childFieldset = $template.clone();

      this.updateIndexedAttributes($childFieldset, currentIndex, nextIndex);
      this.resetChildFieldset($childFieldset);
      this.registerChildValidations(nextIndex);
      $template.after($childFieldset);
      this.attachChildValidationEvents(nextIndex);
      this.updateChildRemoveButtons();
      this.updateAddChildButtonState();
    });
  }

  initRemoveChildButton() {
    this.$form.on('click', '.form-title-holder > button[type="button"]', (event) => {
      const $button = $(event.currentTarget);

      if ($button.prop('hidden')) {
        return;
      }

      const $fieldset = $button.closest(this.getChildFieldsetSelector());
      const childIndex = this.getChildIndex($fieldset);

      if (childIndex <= 0) {
        return;
      }

      this.unregisterChildValidations(childIndex);
      $fieldset.remove();
      this.updateChildRemoveButtons();
      this.updateAddChildButtonState();
    });
  }

  getChildFieldsetSelector() {
    return 'fieldset[name^="child_"]';
  }

  getChildFieldsets() {
    return this.$form.find(this.getChildFieldsetSelector());
  }

  getLastChildFieldset() {
    return this.getChildFieldsets().last();
  }

  getChildCount() {
    return this.getChildFieldsets().length;
  }

  getNextChildIndex() {
    return this.getChildIndex(this.getLastChildFieldset()) + 1;
  }

  getChildIndex($fieldset) {
    const fieldsetName = $fieldset.attr('name') || '';
    const match = fieldsetName.match(/_(\d+)$/);

    return match ? parseInt(match[1], 10) : 0;
  }

  updateIndexedAttributes($fieldset, oldIndex, newIndex) {
    const replaceIndex = (value, attributeName) => {
      if (!value) {
        return value;
      }

      if (attributeName === 'name' && value.indexOf('children[') === 0) {
        return value.replace(`children[${oldIndex}]`, `children[${newIndex}]`);
      }

      if (attributeName === 'id' || attributeName === 'for') {
        return value.replace(`children-${oldIndex}-`, `children-${newIndex}-`);
      }

      if (attributeName === 'fieldset-name') {
        return value.replace(`child_${oldIndex}`, `child_${newIndex}`);
      }

      return value;
    };

    $fieldset.attr('name', replaceIndex($fieldset.attr('name'), 'fieldset-name'));
    $fieldset.find('[name]').each((index, element) => {
      const $element = $(element);
      $element.attr('name', replaceIndex($element.attr('name'), 'name'));
    });
    $fieldset.find('[id]').each((index, element) => {
      const $element = $(element);
      $element.attr('id', replaceIndex($element.attr('id'), 'id'));
    });
    $fieldset.find('[for]').each((index, element) => {
      const $element = $(element);
      $element.attr('for', replaceIndex($element.attr('for'), 'for'));
    });
  }

  resetChildFieldset($fieldset) {
    $fieldset.find('input[type="text"], input[type="date"]').val('');
    $fieldset.find('input[type="radio"]').prop('checked', false);
    $fieldset.find('.form-group').removeClass('has-error has-success');
    $fieldset.find('.has-value').removeClass('has-value');
    $fieldset.find('.form-title-holder').css('background-color', '');
  }

  getChildValidationConfig(childIndex) {
    return {
      [`children[${childIndex}][name]`]: ['required'],
      [`children[${childIndex}][birthday]`]: ['required'],
      [`children[${childIndex}][gender]`]: [{rule: 'radioChecked', param: `children[${childIndex}][gender]`}],
    };
  }

  registerChildValidations(childIndex) {
    Object.assign(this.validations, this.getChildValidationConfig(childIndex));
  }

  unregisterChildValidations(childIndex) {
    Object.keys(this.getChildValidationConfig(childIndex)).forEach((fieldName) => {
      delete this.validations[fieldName];
    });
  }

  attachChildValidationEvents(childIndex) {
    const validations = this.getChildValidationConfig(childIndex);

    Object.keys(validations).forEach((fieldName) => {
      const rules = validations[fieldName];
      const inputType = ValidatedFormView.getInputType(fieldName);
      const eventType = ['file', 'checkbox', 'radio'].indexOf(inputType) >= 0 ? 'change' : 'focusout';

      this.attachEvent(eventType, fieldName, rules);
    });
  }

  syncChildValidations() {
    Object.keys(this.validations).forEach((fieldName) => {
      if (/^children\[\d+\]\[(name|birthday|gender)\]$/.test(fieldName) && fieldName !== 'children[0][name]' && fieldName !== 'children[0][birthday]' && fieldName !== 'children[0][gender]') {
        delete this.validations[fieldName];
      }
    });

    this.getChildFieldsets().each((index, fieldset) => {
      const childIndex = this.getChildIndex($(fieldset));

      if (childIndex > 0) {
        this.registerChildValidations(childIndex);
      }
    });
  }

  updateChildRemoveButtons() {
    this.getChildFieldsets().each((index, fieldset) => {
      const $fieldset = $(fieldset);
      const $button = $fieldset.find('.form-title-holder > button[type="button"]').first();
      const childIndex = this.getChildIndex($fieldset);

      $button.prop('hidden', childIndex <= 0);
    });
  }

  updateAddChildButtonState() {
    const hasReachedLimit = this.getChildCount() >= MAX_CHILDREN;
    this.$form.find('#input-add-child').prop('hidden', hasReachedLimit);
  }

  /*
   * Scroll to the first error message inside the modal body
   */
  scrollToErrorMessage() {
    const $errorMessages = this.$form.find('.form-alert, .has-error');

    if (!$errorMessages.length) {
      return;
    }

    const $modal = this.$form.closest('.modal');

    if (!$modal.length) {
      super.scrollToErrorMessage();
      return;
    }

    const $firstError = $errorMessages.first();
    const modalBodyTop = $modal.offset().top;
    const errorTop = $firstError.offset().top;
    const currentScrollTop = $modal.scrollTop();

    $modal.animate({
      scrollTop: currentScrollTop + errorTop - modalBodyTop,
    }, 1000);
  }

  getPayload() {
    const payload = {
      children: [],
      privacyPolicy: this.$form.find('[name="privacyPolicy"]').prop('checked'),
      email: this.$form.find('[name="email"]').val(),
    };
    const childrenMap = {};

    this.$form.serializeArray().forEach(({name, value}) => {
      const childMatch = name.match(/^children\[(\d+)\]\[(name|birthday|gender)\]$/);

      if (childMatch) {
        const childIndex = parseInt(childMatch[1], 10);
        const fieldName = childMatch[2];

        if (!childrenMap[childIndex]) {
          childrenMap[childIndex] = {};
        }

        childrenMap[childIndex][fieldName] = value;
      }
    });

    payload.children = Object.keys(childrenMap)
      .map((childIndex) => parseInt(childIndex, 10))
      .sort((a, b) => a - b)
      .map((childIndex) => childrenMap[childIndex]);

    return payload;
  }

  doSubmit(event) {
    event.preventDefault();

    const $form = this.$form;
    const payload = this.getPayload();
    const $submitButton = $form.find('button[type="submit"]');
    // use first segment of the path to construct the request URL, e.g. "/checklisten-schwangerschaft-geburt"(EF) or "/" if the path is empty (DDEV)
    const firstSegmentMatch = window.location.pathname.match(/^\/[^/]+/);
    const basePath = firstSegmentMatch ? firstSegmentMatch[0] : '';
    const requestUrl = `${window.location.origin}${basePath}/api/newsletter`;

    this.hideError();
    $submitButton.prop('disabled', true);

    fetch(requestUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (response.status !== 202) {
          this.showError();
          return;
        }
        this.showConfirmation();
      })
      .catch(() => {
        this.showError();
      })
      .finally(() => {
        $submitButton.prop('disabled', false);
      });
  }

  showConfirmation() {
    const $modalBody = this.$form.closest('.modal-body');
    $modalBody.find('[data-form]').attr('hidden', true);
    $modalBody.find('[data-confirmation]').attr('hidden', false);
  }

  showError() {
    const $modalBody = this.$form.closest('.modal-body');
    $modalBody.find('[data-error]').attr('hidden', false);
  }

  hideError() {
    const $modalBody = this.$form.closest('.modal-body');
    $modalBody.find('[data-error]').attr('hidden', true);
  }
}

export default FormBabyJourney;
